import { render } from "./formwork.vue?vue&type=template&id=e747655c"
import script from "./formwork.vue?vue&type=script&lang=js"
export * from "./formwork.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__